import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    EmptyPartContentProps,
    IEmptyHeaderProps
} from "../../type";
import {
    getEmptyHeaderLayout
} from "../../util";
import {
    withEmptyContext
} from "../../context";
import stylesheet from "../../stylesheet";

const EmptyHeaderBase: FC<EmptyPartContentProps<IEmptyHeaderProps>> = ({
    children,
    context,
    style,
    ...props
}) => {
    const layout = getEmptyHeaderLayout(children);

    const renderTexts = () => {
        if(!layout.texts.length) {
            return null;
        }

        return <View
            style={[
                stylesheet.headerText,
                {
                    gap: context.measures.textGap
                }
            ]}
        >
            {layout.texts}
        </View>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.header,
            {
                gap: context.measures.headerGap
            }
        ]}
    >
        {layout.medias}
        {renderTexts()}
    </View>;
};
export default withEmptyContext("header", EmptyHeaderBase);
